/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/lodash/_freeGlobal.js
// module id = 713
// module chunks = 168707334958949